import posthog from 'posthog-js';

export default {
  install(Vue) {
    posthog.init('phc_kYMKXCuS6fdtStVHRKdk8sBiWAqdASfAjLhPLtL7zqCk', {
      api_host: 'https://t.misteriosdaalma.com',
      ui_host: 'https://us.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: false,
      capture_pageleave: true,
      loaded: () => {
        if (process.env.NODE_ENV === 'development') {
          console.log('PostHog inicializado');
        }
      }
    });

    Vue.prototype.$posthog = posthog;
  }
};
